export const SET_FEATURE_FLAGS = 'SET - Feature Flags'

export default {
  [SET_FEATURE_FLAGS](state, payload) {
    state.featureFlags = { ...payload }
    state.loaded = true
  },
}
